import { createFileRoute } from '@tanstack/react-router';
import { AdminSeedPage } from '../../features/directory';

export const Route = createFileRoute('/admin/seed')({ component: AdminSeedPage });
